﻿'use strict';

angular.module('ntmApp').factory('ActivitiesGroupSkillsValidator', ['ActivitySkillsValidator', function (ActivitySkillsValidator) {

    function ActivitiesGroupSkillsValidator(activities, dow, header, skillsProvider,isExistingAssignments) {

        var self = this;

        self.activities = activities;
        self.dow = dow;
        self.header = header;
        self.skillsProvider = skillsProvider;

        self.ActivityNewStatusId = 1;
        self.ActivityLapsedStatusId = 5;
        
        self.isValid = function () {

            self.activities = self.activities.filter(function (item) { return item.activityStatusId === self.ActivityNewStatusId || item.activityStatusId === self.ActivityLapsedStatusId; });

            if (!isExistingAssignments) {
                self.activities = self.activities.filter(function (item) { return item.assignmentId === null; });
            }



            for (var i = 0; i < self.activities.length; i++) {

                var validator = new ActivitySkillsValidator(self.activities[i], dow, header, skillsProvider);

                if (!validator.isValid()) {
                    return false;
                }
            }

            return true;
        };

        self.warningMessage = function () {

            return "Warning: {0} is not qualified to perform the following: <br /><br /> {1} Assign anyway?"
                                         .format(self.header.staffName, self.getNonValidActivitiesList());
        };

        self.getNonValidActivitiesArray = function () {
            

            var compareActivitiesByNameAndSpeciesName = function (activity1, activity2) {
                return activity1.activity === activity2.activity && activity1.speciesName === activity2.speciesName;
            };

            var nonValidActivities = self.activities.filter(function (activity) {
                var validator = new ActivitySkillsValidator(activity, self.dow, self.header, self.skillsProvider);
                return !validator.isValid();
            }).unique(compareActivitiesByNameAndSpeciesName);

            var list = [];

            nonValidActivities.forEach(function (activity) {

                var item = activity.activity;

                if (activity.speciesName) {
                    item += ' on ' + activity.speciesName;
                }
                list.push(item);
            });

            return list;
        };

        self.getNonValidActivitiesList = function () {

            var list = '<ul>';

            var compareActivitiesByNameAndSpeciesName = function (activity1, activity2) {
                return activity1.activity === activity2.activity && activity1.speciesName === activity2.speciesName;
            };

            var nonValidActivities = self.activities.filter(function (activity) {
                var validator = new ActivitySkillsValidator(activity, self.dow, self.header, self.skillsProvider);
                return !validator.isValid();
            }).unique(compareActivitiesByNameAndSpeciesName);

            nonValidActivities.forEach(function (activity) {

                var item = '<li>';
                item += activity.activity;

                if (activity.speciesName) {
                    item += ' on ' + activity.speciesName;
                }

                item += '</li>';
                list += item;
            });

            list += '</ul>';
            return list;
        };
    }

    return (ActivitiesGroupSkillsValidator);
}]);